import { safeRedirectPath, browserAuthReturnPath } from "@/lib/safeRedirect";

const KEY = "checkout-post-booking-profile";
const TTL = 15 * 60_000;
export interface GuestProfileCompletion {
  email: string;
  firstName: string;
  lastName: string;
  next: string;
  expiresAt: number;
}

/** Unverified input, not authentication or account ownership. Used only to
 * prefill an explicit profile submission AFTER genuine mailbox proof. Never
 * store codes, sessions or credentials here. */
export function rememberGuestProfileCompletion(input: Omit<GuestProfileCompletion, "expiresAt">) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({
      email: input.email.trim().toLowerCase(),
      firstName: input.firstName.slice(0, 100),
      lastName: input.lastName.slice(0, 100),
      next: safeRedirectPath(input.next),
      expiresAt: Date.now() + TTL,
    }));
  } catch { /* Normal account completion remains available if storage is blocked. */ }
}

export function clearGuestProfileCompletion() {
  try { sessionStorage.removeItem(KEY); } catch {}
}

export function guestProfileCompletionFor(user: {
  email?: string; email_confirmed_at?: string;
  app_metadata?: Record<string, unknown>;
} | null | undefined): GuestProfileCompletion | null {
  if (!user?.email_confirmed_at || !user.email || user.app_metadata?.checkout_guest === true) return null;
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || "null") as GuestProfileCompletion | null;
    if (!value || !Number.isFinite(value.expiresAt) || value.expiresAt <= Date.now() ||
        value.expiresAt > Date.now() + TTL || typeof value.email !== "string" ||
        value.email !== user.email.trim().toLowerCase() ||
        typeof value.firstName !== "string" || typeof value.lastName !== "string" ||
        typeof value.next !== "string") return null;
    const path = browserAuthReturnPath(window.location, import.meta.env.BASE_URL).split(/[?#]/)[0];
    const returnPath = safeRedirectPath(value.next).split(/[?#]/)[0];
    const accountSurface = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:trips|bookings|profile)(?:\/|$)/i.test(path);
    if (path !== returnPath && !accountSurface) return null;
    return value;
  } catch { return null; }
}
